import { NavFooter } from '@foodsby/nutrient'
import React from 'react'
import { connect } from 'react-redux'

const FOODSBY_BASE_URL = process.env.REACT_APP_FOODSBY_BASE_URL

const Footer = ({ isAuthenticated }) => (
  // todo
  // restaurant turnery
  //    !currentUser && (
  <NavFooter
    links={[
      {
        copy: 'Contact',
        href: isAuthenticated ? `/contact` : `${FOODSBY_BASE_URL}/main/contact/`,
      },
      {
        copy: 'Restaurant Login',
        href: `${FOODSBY_BASE_URL}/main/restaurants-login/`,
      },
      {
        copy: 'Terms of Use',
        href: `/terms-and-conditions`,
      },
      {
        copy: 'Referrals',
        href: `/referral-terms-and-conditions`,
      },
      { copy: 'Privacy Policy', href: `/privacy` },
      {
        copy: 'Ad Choices',
        href: `/privacy#ad-choices`,
      },
      { copy: 'Careers', href: `${FOODSBY_BASE_URL}/main/careers` },
    ]}
  />
)

function mapStateToProps(state) {
  const { currentUser } = state.user
  return {
    currentUser,
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Footer)
